/**
 * Alerts request (F12).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 9.4, PRD F12
 */
import type { AlertsResult } from '@nexus/contracts';

import { api } from '../../../lib/api-client';

export async function listAlerts(): Promise<AlertsResult> {
  return api.get<AlertsResult>('/alerts');
}
